import React, { forwardRef } from "react";
import classes from "./Button.module.scss";
type ButtonProps = {
  children: React.ReactNode;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  type?: "button" | "submit" | "reset";
  style?: React.CSSProperties;
  disabled?: boolean;
  id?:string;
};
const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref)=>{
  const {children, className, onClick, type, style, disabled, ...p} = props;
  return (
    <button
      className={`${classes.btn} ${className}`}
      onClick={onClick}
      type={type}
      style={style}
      disabled={disabled || false}
      ref = {ref}
      {...p}
    >
      {children}
    </button>
  );
});
/*const Button = ({ children, className, onClick, type, style, disabled, ...props }) => {
  return (
    <button
      className={`${classes.btn} ${className}`}
      onClick={onClick}
      type={type}
      style={style}
      disabled={disabled || false}
      {...props}
    >
      {children}
    </button>
  );
};
*/
export default Button;
